<template>
  <div>
    <!-- Header -->
    <v-card class="pa-3 yellow lighten-3" dense>
      <v-row align="center">
        <div class="titulo-centrado red--text text-h6 font-weight-bold ml-3">
          <v-icon left color="red darken-2">mdi-package-variant-closed</v-icon>
          Items Pendientes de OTs - Ubicación y Reserva
        </div>
        <v-spacer></v-spacer>
        <v-col cols="auto">
          <v-btn class="mx-2" fab dark small color="black" @click="$router.push({ name: 'MainDeposito' })">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-card>

    <!-- Filtros -->
    <v-card class="pa-3 yellow lighten-4" dense>
      <v-row dense align="center">
        <v-col cols="12" sm="3" md="2">
          <v-text-field dense v-model="filtroOT" label="N° OT" clearable @keyup.enter="cargarItems" />
        </v-col>
        <v-col cols="12" sm="4" md="3">
          <v-text-field dense v-model="filtroDescripcion" label="Descripción del ítem" clearable @keyup.enter="cargarItems" />
        </v-col>
        <v-col cols="12" sm="3" md="2">
          <v-select dense v-model="filtroEstado" :items="opcionesEstado" item-text="nombre" item-value="valor"
            label="Estado" outlined />
        </v-col>
        <v-col cols="auto">
          <v-btn tile color="success" @click="cargarItems" :loading="loadtable">
            <v-icon left>mdi-magnify</v-icon>Buscar
          </v-btn>
        </v-col>
      </v-row>
    </v-card>

    <!-- Tabla de items pendientes -->
    <v-data-table dense :headers="headers" :items="items" locale="es-ar" class="elevation-1"
      :items-per-page="100" :loading="loadtable" loading-text="Cargando... Espere por favor"
      no-data-text="No hay ítems pendientes" :footer-props="{ itemsPerPageText: 'Ítems por página' }"
      :item-class="rowClass">

      <template v-slot:top>
        <v-toolbar flat dense color="yellow lighten-4">
          <v-toolbar-title class="font-weight-bold">Ítems pendientes de asignación</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-chip small color="orange darken-1" dark class="mr-2">
            {{ items.length }} ítems
          </v-chip>
          <v-chip small color="green darken-1" dark>
            {{ itemsReservados }} reservados
          </v-chip>
        </v-toolbar>
      </template>

      <!-- Columna reservado -->
      <template v-slot:item.reservado="{ item }">
        <v-chip x-small :color="item.reservado === 'S' ? 'green' : 'grey'" dark>
          {{ item.reservado === 'S' ? 'Reservado' : 'Sin reserva' }}
        </v-chip>
      </template>

      <!-- Columna acciones -->
      <template v-slot:item.acciones="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon small color="blue darken-2" class="mr-2" v-on="on" v-bind="attrs"
              @click="abrirDialogUbicacion(item)">
              mdi-map-marker-plus
            </v-icon>
          </template>
          <span>Asignar ubicación y reservar</span>
        </v-tooltip>
        <v-tooltip top v-if="item.ubicacion">
          <template v-slot:activator="{ on, attrs }">
            <v-icon small color="teal" v-on="on" v-bind="attrs">mdi-map-marker-check</v-icon>
          </template>
          <span>Ubicación: {{ item.ubicacion }}</span>
        </v-tooltip>
      </template>
    </v-data-table>

    <!-- Dialog: Asignar ubicación y reservar -->
    <v-dialog v-model="dialogUbicacion" max-width="550px" persistent>
      <v-card>
        <div style="background-color: #b8d4ea; padding: 14px 20px; display: flex; align-items: center; gap: 10px;">
          <v-icon color="#1a3a5c">mdi-map-marker-plus</v-icon>
          <span style="font-size: 15px; font-weight: 700; color: #1a3a5c;">Asignar Ubicación y Reservar</span>
        </div>

        <v-card-text class="pt-4">
          <v-row dense>
            <v-col cols="12">
              <v-text-field dense outlined readonly label="OT" v-model="itemSeleccionado.nrot" />
            </v-col>
            <v-col cols="12">
              <v-text-field dense outlined readonly label="Ítem / Descripción" v-model="itemSeleccionado.descripcion" />
            </v-col>
            <v-col cols="6">
              <v-text-field dense outlined readonly label="Cantidad solicitada" v-model="itemSeleccionado.cantidad" />
            </v-col>
            <v-col cols="6">
              <v-text-field dense outlined readonly label="Unidad" v-model="itemSeleccionado.unidad" />
            </v-col>
            <v-divider class="my-2" />
            <v-col cols="12">
              <v-text-field dense outlined v-model="ubicacionInput" label="Ubicación en depósito *"
                placeholder="Ej: Estante A - Fila 3 - Posición 2"
                :rules="[v => !!v || 'La ubicación es requerida']" ref="inputUbicacion" />
            </v-col>
            <v-col cols="6">
              <v-text-field dense outlined v-model="cantidadDisponible" label="Cantidad disponible en depósito"
                type="number" min="0" />
            </v-col>
            <v-col cols="6">
              <v-checkbox dense v-model="reservar" label="Reservar ítem" color="green darken-2" />
            </v-col>
            <v-col cols="12">
              <v-textarea dense outlined v-model="observacionUbicacion" label="Observaciones" rows="2" />
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn text color="grey darken-1" @click="cerrarDialogUbicacion">Cancelar</v-btn>
          <v-btn color="success" :loading="guardando" @click="guardarUbicacion">
            <v-icon left>mdi-content-save</v-icon>Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog: Guardando -->
    <v-dialog max-width="360" persistent v-model="guardando">
      <v-card style="border-radius: 12px; overflow: hidden;">
        <div style="background-color: #b8d4ea; padding: 14px 20px; display: flex; align-items: center; gap: 10px;">
          <v-icon color="#1a3a5c" size="18">mdi-layers-triple</v-icon>
          <span style="font-size: 14px; font-weight: 700; color: #1a3a5c;">Registro en proceso</span>
        </div>
        <v-card-text style="padding: 32px 24px 24px; text-align: center;">
          <v-progress-circular indeterminate color="#1a3a5c" size="52" width="3" style="margin-bottom: 20px;" />
          <p style="font-size: 15px; font-weight: 500; color: #1a2a3a; margin: 0 0 6px;">Guardando datos</p>
          <p style="font-size: 13px; color: #6b7f92; margin: 0; line-height: 1.6;">
            Por favor aguarde, esto tomará solo un momento...
          </p>
        </v-card-text>
        <div style="background: #f4f7fb; border-top: 1px solid #dde3ea; padding: 11px 20px; display: flex; align-items: center; gap: 8px;">
          <v-icon size="14" color="#5b9ec9">mdi-clock-outline</v-icon>
          <span style="font-size: 11px; color: #6b7f92;">No cierre esta ventana hasta que finalice</span>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Axios from "../../axios-auth";

export default {
  data() {
    return {
      loadtable: false,
      guardando: false,
      dialogUbicacion: false,
      items: [],
      filtroOT: "",
      filtroDescripcion: "",
      filtroEstado: "P",
      opcionesEstado: [
        { nombre: "Pendientes", valor: "P" },
        { nombre: "Reservados", valor: "R" },
        { nombre: "Todos", valor: "T" },
      ],
      headers: [
        { text: "N° OT", value: "nrot", width: "110px", sortable: true },
        { text: "Descripción OT", value: "nombreot", sortable: true },
        { text: "Ítem", value: "descripcion", sortable: true },
        { text: "Cantidad", value: "cantidad", align: "center", width: "90px" },
        { text: "Unidad", value: "unidad", align: "center", width: "80px" },
        { text: "Ubicación", value: "ubicacion", sortable: true },
        { text: "Estado", value: "reservado", align: "center", width: "110px" },
        { text: "Acciones", value: "acciones", sortable: false, align: "center", width: "90px" },
      ],
      itemSeleccionado: {},
      ubicacionInput: "",
      cantidadDisponible: "",
      reservar: false,
      observacionUbicacion: "",
    };
  },

  computed: {
    itemsReservados() {
      return this.items.filter((i) => i.reservado === "S").length;
    },
  },

  mounted() {
    this.cargarItems();
  },

  methods: {
    cargarItems() {
      this.loadtable = true;
      this.items = [];
      Axios.get("/Deposito/ItemsPendientesOT", {
        params: {
          nrot: this.filtroOT,
          descripcion: this.filtroDescripcion,
          estado: this.filtroEstado,
        },
      })
        .then((r) => {
          this.items = r.data;
        })
        .catch(() => {
          this.$swal({ icon: "error", title: "Error al cargar los ítems pendientes", toast: true,
            position: "top-end", showConfirmButton: false, timer: 3000 });
        })
        .finally(() => {
          this.loadtable = false;
        });
    },

    abrirDialogUbicacion(item) {
      this.itemSeleccionado = { ...item };
      this.ubicacionInput = item.ubicacion || "";
      this.cantidadDisponible = item.cantidadDisponible || "";
      this.reservar = item.reservado === "S";
      this.observacionUbicacion = item.observacion || "";
      this.dialogUbicacion = true;
      this.$nextTick(() => {
        if (this.$refs.inputUbicacion) this.$refs.inputUbicacion.focus();
      });
    },

    cerrarDialogUbicacion() {
      this.dialogUbicacion = false;
      this.itemSeleccionado = {};
      this.ubicacionInput = "";
      this.cantidadDisponible = "";
      this.reservar = false;
      this.observacionUbicacion = "";
    },

    guardarUbicacion() {
      if (!this.ubicacionInput) {
        this.$swal({ icon: "warning", title: "Ingrese la ubicación del ítem", toast: true,
          position: "top-end", showConfirmButton: false, timer: 3000 });
        return;
      }
      this.guardando = true;
      this.dialogUbicacion = false;
      Axios.post("/Deposito/GuardarUbicacionItem", {
        id: this.itemSeleccionado.id,
        nrot: this.itemSeleccionado.nrot,
        ubicacion: this.ubicacionInput,
        cantidadDisponible: this.cantidadDisponible,
        reservado: this.reservar ? "S" : "N",
        observacion: this.observacionUbicacion,
        usuario: this.$store.state.usuario,
      })
        .then(() => {
          this.$swal({ icon: "success", title: "Datos guardados correctamente", toast: true,
            position: "top-end", showConfirmButton: false, timer: 3000 });
          this.cargarItems();
          this.cerrarDialogUbicacion();
        })
        .catch(() => {
          this.$swal({ icon: "error", title: "Error al guardar los datos", toast: true,
            position: "top-end", showConfirmButton: false, timer: 3000 });
        })
        .finally(() => {
          this.guardando = false;
        });
    },

    rowClass(item) {
      return item.reservado === "S" ? "green lighten-5" : "";
    },
  },
};
</script>

<style scoped>
.titulo-centrado {
  display: flex;
  align-items: center;
}
</style>
